import React, { useState } from "react";

import InvestorTransferSharesForm from "./InvestorTransferSharesForm";
import TransferRequestConfirmPanel from "./TransferRequestConfirmPanel";
import { transferableSharesFromHolding } from "../../utils/investorTransferShares";
import { projectTitleWithCode } from "../../utils/projectViews";

/**
 * Transfer offer modal — same workflow as the transfer tab on Fundraising / Funded project cards.
 */
export default function TransferSharesRequestModal({ holding, onClose, onSuccess }) {
  const projectId = String(holding?.project_id || holding?.project?.id || "").trim();
  const label =
    projectTitleWithCode(holding?.project || { project_code: holding?.project_code, name: holding?.project_name }) ||
    "Project";
  const sharesAvailable = transferableSharesFromHolding(holding);
  const [successData, setSuccessData] = useState(null);

  if (!holding || !projectId) return null;

  const handleClose = () => {
    if (successData) onSuccess?.(successData);
    onClose?.();
  };

  return (
    <div className="invx-about-modal-overlay" onClick={handleClose} role="presentation">
      <div
        className="invx-about-modal investor-offer-detail redeem-shares-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="transfer-modal-title"
        aria-modal="true"
      >
        <button type="button" className="invx-about-modal-close" onClick={handleClose} aria-label="Close">
          ×
        </button>

        {successData ? (
          <>
            <header className="investor-offer-detail__header" style={{ marginBottom: "0.5rem" }}>
              <div className="investor-offer-detail__header-main">
                <p className="investor-offer-detail__eyebrow">Transfer offer</p>
                <h3 id="transfer-modal-title" className="investor-offer-detail__title">
                  {successData.transfer_ref || "Offer submitted"}
                </h3>
                <p className="investor-offer-detail__project">{label}</p>
              </div>
              <span className="badge badge-PENDING">Pending</span>
            </header>
            <TransferRequestConfirmPanel data={successData} projectLabel={label} onDone={handleClose} />
          </>
        ) : (
          <>
            <h3 id="transfer-modal-title" style={{ marginTop: 0 }}>
              Transfer shares
            </h3>
            <p className="muted" style={{ margin: "0 0 12px" }}>
              {label}
            </p>
            <InvestorTransferSharesForm
              projectId={projectId}
              sharesAvailable={sharesAvailable}
              className="stack"
              title=""
              subtitle=""
              submitLabel="Submit transfer"
              onSuccess={(data) => setSuccessData(data)}
            />
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
              <button type="button" className="btn-secondary" onClick={onClose}>
                Cancel
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
